export interface ImageModel {
    type?: string;
    url?: string;
    orientation?: string;
    name?: string;
    width?: number;
    height?: number;
    dateCreated?: string;
}
